import { createAsyncReducer } from '@telstra-connect/standard-actions';
import _ from 'lodash';
import {
    ILoadEnquiryDetailsAction,
    ILoadEnquiryDetailsSuccessAction,
    LoadEnquiryDetailsErrorAction,
    ILoadQueriedChargesAction,
    ILoadQueriedChargesSuccessAction,
    LoadQueriedChargesErrorAction
} from '../actions/load-enquiry-details';
import { IBillingState } from '../state';
import { initialState } from '../state/initial-state';

export type LoadEnquiryDetails
    = ILoadEnquiryDetailsAction
    | ILoadEnquiryDetailsSuccessAction
    | LoadEnquiryDetailsErrorAction
    | ILoadQueriedChargesAction
    | ILoadQueriedChargesSuccessAction
    | LoadQueriedChargesErrorAction;

const init = (state: IBillingState, action: LoadEnquiryDetails) =>
    ({
        ...state,
        enquiryDetails: {
            ...state.enquiryDetails,
            status: action.status
        }
    });

const success = (state: IBillingState, action: LoadEnquiryDetails) =>
    ({
        ...state,
        enquiryDetails: {
            ...initialState.enquiryDetails,
            status: action.status,
            data: _.omit((action as ILoadEnquiryDetailsSuccessAction).data,
                'queriedCharges')
        }
    });
const failure = (state: IBillingState, action: LoadEnquiryDetails) => ({
    ...state,
    enquiryDetails: {
        ...initialState.enquiryDetails,
        status: action.status,
        error: (action as LoadEnquiryDetailsErrorAction).error,
        errorCode: (action as LoadEnquiryDetailsErrorAction).errorCode
    },
    queriedCharges: {
        ...initialState.queriedCharges,
        status: action.status,
        error: (action as LoadEnquiryDetailsErrorAction).error,
        errorCode: (action as LoadEnquiryDetailsErrorAction).errorCode
    }
});

const reset = (state: IBillingState, action: LoadEnquiryDetails) => ({
    ...state,
    enquiryDetails: {
        ...initialState.enquiryDetails,
    }
});

const initQueriedCharges = (state: IBillingState, action: LoadEnquiryDetails) =>
    ({
        ...state,
        queriedCharges: {
            ...state.queriedCharges,
            status: action.status
        }
    });

const successQueriedCharges = (state: IBillingState, action: LoadEnquiryDetails) =>
    ({
        ...state,
        queriedCharges: {
            status: action.status,
            data: {
                totalSize: (action as ILoadQueriedChargesSuccessAction).data.totalSize,
                queriedCharges: (action as ILoadQueriedChargesSuccessAction).data.queriedCharges,
                nextRecordsUrl: (action as ILoadQueriedChargesSuccessAction).data.nextRecordsUrl,
                done: (action as ILoadQueriedChargesSuccessAction).data.done
            }
        }
    });

const failureQueriedCharges = (state: IBillingState, action: LoadEnquiryDetails) => ({
    ...state,
    queriedCharges: {
        ...initialState.queriedCharges,
        status: action.status,
        error: (action as LoadQueriedChargesErrorAction).error,
        errorCode: (action as LoadQueriedChargesErrorAction).errorCode
    }
});

const resetQueriedCharges = (state: IBillingState, action: LoadEnquiryDetails) => ({
    ...state,
    queriedCharges: {
        ...initialState.queriedCharges,
    }
})

export const loadenquiryDetailsReducer = createAsyncReducer(initialState, init, success, failure, reset);
export const loadQueriedChargesReducer = createAsyncReducer(initialState,
    initQueriedCharges, successQueriedCharges, failureQueriedCharges, resetQueriedCharges);
